import React, { useEffect, useState } from 'react'
import { withRouter } from "../hooks/withRouter"
import { getPredialDetalle } from '../api/consultaPredialApi';
import { Link } from "react-router-dom";
import { UseAuth } from "../hooks/useAuth";






function BusquedaDetalles(props) {
    const { location } = props.router;

    const [result, setResult] = useState([])
    const url = location.pathname.split("/")
    const id = url[2]
    const { accessToken } = UseAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps

    useEffect(() => {
        getPredialDetalle(accessToken, id).then((response) => {
            if (response?.code !== 200) {

                setResult(response)
            } else {
            }
        }).catch(() => {


        });

    }, [accessToken,id]);

    if (result.length < 1) {
        return "loading"
    }

    return (
        <div>


          <div className='top-bar2'>
            <div className="top-bar">

                <div className="logo">
                    {/* Botón con apariencia de logo que lleva a la página principal */}
                    <Link to="/">
                        <button className="logo-button">
                            <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                        </button>
                    </Link>
                </div>
            </div>

            </div>
            <>

                    <div class="acta-container">
                            <h1>Padron Predial</h1>
                {result.map((res, index) => (
                    <div key={index}>
                        <h1>{res.CONTRIBUYENTE}</h1>
                        <div className="acta" >
                            <div className='column'>

                                <h1> Clave Catastral</h1>
                                <p className="letra">{res.clave_catastral} </p>
                                <h1> Clave Catastral Anterior</h1>
                                <p className="letra"> {res.clave_catastral_anterior}</p>
                                <h1> Tipo de Predio</h1>
                                <p className="letra">{res.ambito}</p>
                                <h1> Contribuyente</h1>
                                <p className="letra">{res.razon_social}</p>


                            </div>
                            <div className='column'>
                                <h1> Nombre</h1>
                                <p className="letra"> {res.nombre}</p>
                                <h1>Apellido Paaterno </h1>
                                <p className="letra"> {res.primer_apellido}</p>
                                <h1> Apellido Materno </h1>
                                <p className="letra"> {res.segundo_apellido}</p>
                                <h1> Razon Social </h1>
                                <p className="letra"> {res.razon_social}</p>
                                <h1>RFC </h1>
                                <p className="letra">{res.rfc} </p>


                            </div>
                            <div className='column'>
                                <h1> Municipio</h1>
                                <p className="letra">{res.municipio} </p>
                                <h1> Ubicacion Del Predio </h1>
                                <p className="letra"> {res.ubicacion_predio} </p>
                                <h1> Domicilio A Notificar </h1>
                                <p className="letra"> {res.domicilio_a_notioficar}</p>
                                <h1>  Superficie Construccion </h1>
                                <p className="letra">{res.superficie_construccion}</p>
                                <h1> Superficie Terreno </h1>
                                <p className="letra"> {res.superficie_terreno}</p>



                            </div>



                        </div>
                    </div>
                ))}
                </div>
            </>
        </div>
    )
}

export default withRouter(BusquedaDetalles)
